export default {
  GUEST: 1,
  BUDDY: 2,
  OWNER: 3
}
